import { receiptsApi } from '../api/receiptsApi'

export const downloadReceipt = async (donationId: string) => {
  try {
    const response = await receiptsApi.downloadReceipt(donationId)
    return response.data
  } catch (error) {
    console.error(`Error sending receipt email: `, error)
    throw error
  }
}
